import { createStore } from "vuex";
import { definiciones } from "@/icontaelibs.js";
import axios from "axios";
//axios.defaults.baseURL = definiciones.URL_API+"";
axios.defaults.baseURL = definiciones.URL_API+"";
export default createStore({
  state() {
    return {
      user: null,
      empresa: null,
    };
  },
  mutations: {
    setEmpresaData(state, empresaData) {
      console.log("setempresa");
      
      (state.empresa = empresaData),
        localStorage.setItem("empresa", JSON.stringify(empresaData));
      console.log(state.empresa);
        
    },

    setUserData(state, userData) {
      console.log("setuser");
      console.log(userData);
      (state.user = userData),
        localStorage.setItem("user", JSON.stringify(userData));
        
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
    },

    clearUserData() {
      localStorage.removeItem("user");
      localStorage.removeItem("empresa");
      location.reload();
    },
  },
  actions: {
    login({ commit }, credentials) {
      console.log("aqui entra");
      console.log(credentials);
      return axios.post("/login", credentials).then(({ data }) => {
        commit("setUserData", data);
      });
    },

    logout({ commit }) {
      commit("clearUserData");
    },

    selectempresa({ commit }, data) {
      commit("setEmpresaData", data);
    },
  },
  getters: {
    isLogged: (state) => !!state.user,
    isEmpresa: (state) => !!state.empresa,
     
    dataEmpresa: (state) => {
      return state.empresa;
    },
    
  },
});
